export const comments_4180329 = {"data":{"data":[],"links":{}}}